import { ISuggestionsModel } from './model';

export default (self: ISuggestionsModel) => ({
  get sortedList() {
    return self.toArray.sort((a, b) => {
      if (!a.created_at && !b.created_at) return 0;
      if (!a.created_at) return 1;
      if (!b.created_at) return -1;

      return b.created_at - a.created_at;
    });
  }
});
